import { createSlice } from '@reduxjs/toolkit';

type AsrState = {
  providerId: string;
  modelId: string;
  language: string;

  config?: Record<string, unknown>;
};

const initialState: AsrState = {
  providerId: '',
  modelId: '',
  language: '',

  config: undefined,
};

const asrSlice = createSlice({
  name: 'asr',
  initialState,
  reducers: {},
});

export default asrSlice.reducer;
